module.exports = __webpack_public_path__ + "static/media/full_program.d75b8572.png";